import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES, MAX_SMALL_MOBILE_WIDTH } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IApiErrors, IUploadedDoc } from '../../context/model';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import LoaderModal from '../../modals/common/LoaderModal';
import QrCodeModal from '../../modals/common/QrCodeModal';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { deleteDocument, downloadUploadedDocument, uploadFamilyDocument } from "../../services/CustomerApiService";
import { getRequireFamilyDocumentTypes, isPropositionInLock } from '../../utils/dataUtils';
import { accessJsonAttr, getDayDifferent, getFilename, scroll2Top } from '../../utils/utils';
import ListOfFileUploaded from '../common/ListOfFileUploaded';
import UploadFromPhoneButton from '../common/UploadFromPhoneButton';
import UploadDocumentButton from '../common/UploadDocumentButton';
import UploadMultipleComponent from '../common/UploadMultipleComponent';


type FileFormData = {
  id: string, 
  name: string
}

type FamilyDocumentsFormData = {
  files: FileFormData[],
}



export default function FamilyDocumentsFormComponent() {

  const {
    state: { proposition, jwtToken, familyDoc, updatedProposition, showModal, additionalData },
    dispatch,
  } = useAppState();

  const documentsRequired = getRequireFamilyDocumentTypes(updatedProposition!, additionalData);
  const fileNameHandicap = "justificatifEnfantHandicap";
 
  const validationSchema = Yup.object().shape({
    files: Yup.array().min(documentsRequired.length).required(ERROR_MESSAGES.requiredMsg)
  });
  
  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<any>({});
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [fileFamily, setFileFamily] = useState<File | null>(null);
  const [success, setSuccess] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fileType, setFileType] = useState<string>('');
  const [uploadMode, setUploadMode] = useState<boolean>(true);
  const [showQrModal, setShowQrModal] = useState<boolean>(false);
  const [docCode, setDocCode] = useState<string>('');
  const [showUploadMultiple, setShowUploadMultiple] = useState<boolean>(false);
  const [hasMultipleFile, setHasMulipleFile] = useState<boolean>(false);


  const navigate = useNavigate();

  const {width} = useWindowDimensions();
  const isDesktop = width > MAX_SMALL_MOBILE_WIDTH;

  const showQrCodeModal = (docCode: string) => {
    setShowQrModal(true);
    setDocCode(docCode);
  }
  const closeQrModal = () => {
    setShowQrModal(false);
  }

  const {
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<FamilyDocumentsFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
        files: [...familyDoc],
      },
    resolver: yupResolver(validationSchema),
  });

  const closeModal = () => {
    setModalIsOpen(false);
    setUploadMode(true);
    dispatch({type: 'SHOW_MODAL', showModal: false});
  };
 
  const onSubmit = async () => {
      setSuccess(true);

      const arrUpdateDocs = familyDoc.filter(el => !el.fileName?.includes(fileNameHandicap));
      dispatch({type: 'UPLOAD_FAMILY_DOCUMENT', familyDoc: updatedProposition?.beneficiaries?.find(el => el.contact.hasHandicap) ? familyDoc : arrUpdateDocs});

      let nextUrl = APP_URLS.recapPage;
   
      if(proposition?.configuration.hasOfferStep) {
        nextUrl = APP_URLS.guarantyPage;
      } else if(proposition?.configuration.hasPreviousInsuranceTermination && getDayDifferent(proposition?.effectiveDate) > 32) {
        nextUrl = APP_URLS.infoOldContractPage;
      }
      dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
      navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
      }); 
  }

  const documentSubmit = async (fileUpload: File) => {
    setErrorMsg(null);
    setErrorFileTypeMsg({});
    setErrorFileSizeMsg({});
    setLoading(true);
    try {
      const token = jwtToken!.accessToken;
      const res = await uploadFamilyDocument(token, proposition!.propositionId, fileUpload, fileType);
      const docs = [...familyDoc, {id: res.data.id, name: res.data.name, fileName: res.data.fileName}]

      dispatch({type: 'UPLOAD_FAMILY_DOCUMENT', familyDoc: getUpdateDocs(docs)});
      setValue('files', getUpdateDocs(docs));
      
      setLoading(false);
      setModalIsOpen(false);
      setShowUploadMultiple(false);
      scroll2Top();
      dispatch({type: 'SHOW_MODAL', showModal: false});
    } catch (error) {
      setLoading(false);
      setShowUploadMultiple(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }


  const onEventMessage = (message: any, type: string) => {
    if(type === 'upload') {
      const docs = [...familyDoc, {id: message.id, name: message.name, fileName: message.fileName}]
      dispatch({type: 'UPLOAD_FAMILY_DOCUMENT', familyDoc: docs});
      setValue('files', docs);
      setLoading(false);
      setShowQrModal(false);
    }
  }

  const downloadDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
      const content = new Blob([res.data], {type: res.headers['content-type']});
      const filename = getFilename(res.headers);
      const file = new File([content], filename);
      setFileFamily(file);
      setUploadMode(false);
      setModalIsOpen(true);
      dispatch({type: 'SHOW_MODAL', showModal: true});
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        setErrorMsg(ERROR_MESSAGES.documentNotFound);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onPreviousAction = () => { 
    if (additionalData?.hasPartner || additionalData?.hasChild ) {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoBeneficiaryStep2Page});
      navigate({
      pathname: APP_URLS.infoBeneficiaryStep2Page,
      search: `?id=${proposition!.propositionId}`,
      }); 
    } else {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoBeneficiaryStep0Page});
      navigate({
      pathname: APP_URLS.infoBeneficiaryStep0Page,
      search: `?id=${proposition!.propositionId}`,
      }); 
    }
  
  }

  const getUpdateDocs = (docs : IUploadedDoc[]) => {
    let handicapDocs = docs.filter(doc => doc.fileName!.includes(fileNameHandicap))
                            .map((doc, index) => ({
                              ...doc,
                              fileName: `${fileNameHandicap}_${index}` 
                            }));

    let otherDocs = docs.filter(doc => !doc.fileName!.includes(fileNameHandicap));
    let updatedDocs = [...otherDocs, ...handicapDocs];

    return updatedDocs;
  }

  const onDeleteDocLocal = (documentId: string) => {
    let result = [...familyDoc];
    const index = result.findIndex(el => el.id === documentId);
    result.splice(index, 1);

    dispatch({type: 'UPLOAD_FAMILY_DOCUMENT', familyDoc: getUpdateDocs(result)});
    setValue('files', getUpdateDocs(result));
  }

  const handleDeleteFile = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      await deleteDocument(token, proposition!.propositionId, documentId);
      
      onDeleteDocLocal(documentId);
      setErrorMsg(null);

    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        onDeleteDocLocal(documentId);
        setErrorMsg(null);
      }else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  };


  return (
      <>
      {!success && <form style={{width: '100%'}}>
       
        <p className="text m-y-sm">Pour la complétude de votre dossier, veuillez télécharger l’ensemble du document demandé.</p>
        {
          hasMultipleFile && <MgpMessage type='info' message='Vos fichiers ont bien été fusionnés et téléchargés' hasCloseBtn={true} />
        }

        {
            documentsRequired?.map((doc, i) => {
                const tempDoc = familyDoc?.find(el => el.fileName?.includes(doc.fileName));
              return (
                <div key={doc.code}>
                  <div className='form-row mw-70'>
                    {
                      tempDoc &&
                      <div className='m-y-xs'>
                        <ListOfFileUploaded 
                          fileName={tempDoc.name}
                          onDownloadDocument={() => downloadDocument(tempDoc.id)}
                          onDeleteDocument={() => handleDeleteFile(tempDoc.id)}
                        />
                      </div>
                    }
                  </div>

                  {
                    !tempDoc && 
                    <div>
                      <div className='form-row'>
                        <div className='form-group mw-70'>
                            {errorFileTypeMsg[doc.code]&& <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileTypeMsg}</p>}

                        </div>
                      </div> 
                      <div>  
                        <p>{doc.label}<span className="fushia"> (*)</span></p>
                        <div className="form-row">
                          <div className='form-group mw-30'>
                            <UploadDocumentButton onClick={() =>  {
                                  setFileType(doc.code.includes(fileNameHandicap) ? "CHILD_HANDICAP_PROOF" : doc.code);
                                  setShowUploadMultiple(true)}}/>
                          </div>
                          {
                            isDesktop && <div className="form-group mw-5 ta-center"><p className='fz-lg' style={{marginTop: "100px"}}>ou</p></div>
                          }
                          {isDesktop && 
                          <div className='form-group mw-30'>
                            <UploadFromPhoneButton onClick={() => showQrCodeModal(doc.code.includes(fileNameHandicap) ? fileNameHandicap : doc.code)}/> 
                          </div>}
                      
                        </div>
                      </div>
                      {!errorFileTypeMsg[doc.code] &&  errors && accessJsonAttr(errors, 'files') && <p className="error mt-sm fushia">(*) Merci de télécharger tous les documents demandés</p>} 
                    </div>
                  }    
                </div>
              
              )})
            }

        
        {errorMsg && <div className='mt-md'><MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/></div>}
        

        <div className="pt-xl">
          <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
        </div>

        {modalIsOpen && fileFamily &&<UploadFilePreviewModal file={fileFamily} onUploadAction={() => documentSubmit(fileFamily)} isOpen={modalIsOpen} onCloseModal={closeModal} showButton={uploadMode}/>}
       
        {
          !showModal && !showUploadMultiple && <StickButtonsBloc disabledPreviousButton={(proposition && isPropositionInLock(proposition)) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onSubmit)}/>
        }
       
        {showQrModal&&<QrCodeModal isOpen={showQrModal} onCloseModal={closeQrModal} docCode={docCode} onEventMessage={onEventMessage}/>}

        {showUploadMultiple && <UploadMultipleComponent isOpen={showUploadMultiple} onCloseModal={() => setShowUploadMultiple(false)} docType={fileType} onUploadAction={documentSubmit} setHasMultipleFile={(response : boolean) => setHasMulipleFile(response) }/>}

        {(isSubmitting || loading) && <LoaderModal hasMessage={false}/>}
        <div>
       
        </div>
      </form>}
      </>
  )
}
